module.exports = __webpack_public_path__ + "media/audio13.1ba98fa9.mp3";